$(document).ready(function() {
    $('#sliderProjects').slick({
        dots: false,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: false,
        autoplay: false,
        autoplaySpeed: 4000,
        swipe: true,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
    });
});
